"use client";
import Icon from "../icons/Icons";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const testimonials = [
  {
    title: "Deepak",
    sub_title: "28 M",
    script:
      "After three years of investing, my portfolio lacked real diversification. MySIPonline's Portfolio Analysis flagged the overlap instantly, and their rebalancing plan fixed it within days. It finally works for my goals, not against them.",
  },
  {
    title: "Amit",
    sub_title: "32 M",
    script:
      "I'm analytical, so too many fund options left me stuck. A colleague recommended MySIPonline, whose research-backed process helped me build a diversified portfolio matched to my risk profile. I invest with clarity now, not guesswork.",
  },
  {
    title: "Deepesh",
    sub_title: "33 M",
    script:
      "I started my first SIP with MySIPonline after struggling to shortlist funds alone. Their Risk Profile Test matched me with the right categories, and onboarding was quick and paperwork free. Investing finally feels manageable.",
  },
  {
    title: "Anupriya",
    sub_title: "31 W",
    script:
      "Switching funds always felt risky until MySIPonline's Overlap Detection tool showed where my holdings duplicated. Their team suggested a cleaner allocation, and the switch was handled smoothly. My portfolio finally feels intentional, not accidental.",
  },
  {
    title: "Gaurav",
    sub_title: "24 M",
    script:
      "As a first-time investor, SIP versus lump sum confused me until MySIPonline's advisors explained both based on my goals and timeline. Their calculator made the projections easy to follow, and I started my SIP that same week.",
  },
];

export default function HomeTestimonialsSection() {
  return (
    <div className="w-full">
      <Swiper
        modules={[Navigation, Pagination]}
        spaceBetween={0}
        slidesPerView="auto"
        initialSlide={Math.floor(testimonials.length / 2)}
        navigation={{
          prevEl: ".testimonial-prev",
          nextEl: ".testimonial-next",
        }}
        centeredSlides
        centeredSlidesBounds={false}
        pagination={{
          el: ".testimonial-pagination",
          clickable: true,
          dynamicBullets: true,
          dynamicMainBullets: 3,
        }}
        allowTouchMove
      >
        {testimonials.map((item, ind) => (
          <SwiperSlide
            key={`${item.title}-${ind}`}
            className="max-w-fit py-5 px-2 sm:py-8 sm:px-4 max-h-fit"
          >
            <div className="w-72 sm:w-105.5 h-64 sm:h-80 flex flex-col rounded-4xl sm:rounded-6xl border border-gray-100 bg-white p-4 sm:p-6 shadow-[0px_8px_30px_0px_#0000000A]">
              <div
                className={[
                  "h-full max-h-36 sm:max-h-44 overflow-x-auto scrollbar-xs",
                  item.script ? "pr-1.5 sm:pr-2" : "w-full",
                ].join(" ")}
              >
                {/* {item.script ? (
                  <p className="text-2xs sm:text-base lg:text-lg font-medium tracking-[-0.45px] text-[#1E2939]">&quot;{item.script}&quot;</p>
                ) : (
                  <button
                    type="button"
                    onClick={() => dispatch(openVideoMPModal(item.video_url ?? ""))}
                    className="group relative flex w-full h-full overflow-hidden items-center justify-center rounded-2xl bg-[#f5f5f5]"
                  >
                    <span className="flex h-14 w-14 relative z-1 items-center justify-center rounded-full bg-black/30 backdrop-blur-sm pointer-events-none">
                      <Icon.ytVideoFilledIcon className="text-white" />
                    </span>

                    {item.image_url && (
                      <Image
                        src={item.image_url ?? ""}
                        alt="Testimonial Users Feedback Videos"
                        fill
                        className="object-fill transition-transform duration-350 sm:group-hover:scale-105 z-0"
                        onError={(e) => {
                          e.currentTarget.style.display = "none";
                        }}
                      />
                    )}
                  </button>
                )} */}

                <p className="text-2xs sm:text-base lg:text-lg font-medium tracking-[-0.45px] text-[#1E2939]">
                  &quot;{item.script}&quot;
                </p>
              </div>

              <div className="flex items-center gap-2.5 sm:gap-3 pt-3.5 sm:pt-6 mt-auto border-t border-gray-100">
                <div className="flex w-12 h-12 items-center justify-center rounded-full bg-[#dddddd] text-lg font-semibold text-(--primary)">
                  {item.title.charAt(0).toUpperCase()}
                </div>

                <div>
                  <div className="text-2sm font-semibold text-[#1D2939]">
                    {item.title}
                  </div>

                  <p className="text-2xs text-[#667085]">{item.sub_title}</p>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="mt-10 flex items-center justify-center gap-2 sm:gap-3">
        <button
          className="testimonial-prev flex w-9 h-9 sm:w-12 sm:h-12 items-center justify-center rounded-full border-2 border-[#1558C0] text-[#1558C0] transition hover:bg-[#1558C0] hover:text-white"
          type="button"
        >
          <Icon.rightArrow className="rotate-180" />
        </button>

        <div className="testimonial-pagination static! w-auto! inset-auto! transform-none! flex items-center justify-center" />

        <button
          className="testimonial-next flex w-9 h-9 sm:w-12 sm:h-12 items-center justify-center rounded-full border-2 border-[#1558C0] text-[#1558C0] transition hover:bg-[#1558C0] hover:text-white"
          type="button"
        >
          <Icon.rightArrow />
        </button>
      </div>
    </div>
  );
}
